import Vue from 'vue'
import Vuex from 'vuex'
import baseStore from './baseStore'

Vue.use(Vuex);

const moduleFiles = require.context('./modules', false, /\.js$/)

moduleFiles.keys().reduce((store, module) => {
  let moduleName = module.split('./')[1].replace(/\.js$/, '');
  let modeleContent = moduleFiles(module).default

  modeleContent.namespaced = true;
  store.modules? store.modules : {};
  store.modules[moduleName] = modeleContent;
  return store
}, baseStore)

export default new Vuex.Store(baseStore)
